export default "__VITE_ASSET__DOYXmwnw__";